import React from 'react';
import ReactDOM from 'react-dom/client';
// Brand fonts (self-hosted @font-face): Infiniwell (brand) + Inter (UI/body).
import './common/theme/fonts.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);